/**
 * ReviewDetailLayout — the card arrangement for one flagged item (BON-381).
 *
 * Desktop keeps the design's two-column grid: the flag and the evidence on the
 * left, the resources to follow and the money on the right. On a phone the
 * columns collapse to one, ordered by what an operator reads first — the flag,
 * then the money, then the trail, then where to go.
 *
 * There is one trail, not two: "Review history" was deleted because `timeline`
 * already contains every lifecycle entry it carried, plus the sources it never
 * had.
 */
import type { ReactNode } from 'react';

import { ReviewFlagCard } from './ReviewFlagCard';
import { ReviewLinkedCard } from './ReviewLinkedCard';
import { ReviewMoneyCard } from './ReviewMoneyCard';
import { ReviewTimelineCard } from './ReviewTimelineCard';
import type { ReviewDetail } from './reviewTypes';

export interface ReviewDetailLayoutProps {
  detail: ReviewDetail;
  /** The note composer, when open. */
  composer: ReactNode;
  isPhone: boolean;
}

export function ReviewDetailLayout({ detail, composer, isPhone }: ReviewDetailLayoutProps) {
  const flag = <ReviewFlagCard detail={detail} />;
  const money = <ReviewMoneyCard detail={detail} />;
  const timeline = <ReviewTimelineCard entries={detail.timeline} />;
  const links = <ReviewLinkedCard detail={detail} />;

  if (isPhone) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        {flag}
        {composer}
        {money}
        {timeline}
        {links}
      </div>
    );
  }

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'minmax(0,1.35fr) minmax(0,1fr)',
        gap: 16,
        alignItems: 'start',
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
        {flag}
        {composer}
        {timeline}
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
        {links}
        {money}
      </div>
    </div>
  );
}
